import { ProfileDialog } from '@strata/react-dialog';
import { Grid } from '@strata/react-grid';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { getUserProfile, updateProfile } from 'api/profileAPI';
import { handleError } from 'services/Error';

const mapProfileFromApi = (profile) => ({
    fullName: profile.prescriber_name,
    email: profile.upn,
    organizations: profile.identities?.map((prescriber) => ({
        prescriberNpi: prescriber.prescriber_npi,
        role: prescriber.display_name,
    })),
});

export const UserProfileDialog = ({ isOpen, onSecondaryButtonClick }) => {
    const [profile, setProfile] = useState();
    useEffect(() => {
        void (async () => {
            if (isOpen) {
                try {
                    setProfile(mapProfileFromApi(await getUserProfile()));
                } catch (err) {
                    onSecondaryButtonClick();
                    handleError('An error occurred retrieving profile settings.', err);
                }
            }
        })();
    }, [isOpen, onSecondaryButtonClick]);

    const onSubmit = async (values) => {
        try {
            await updateProfile(values);
            SuccessToast({ message: 'Your profile settings were updated successfully.' });
            onSecondaryButtonClick();
        } catch (err) {
            handleError('An error occurred updating profile settings.', err);
        }
    };

    return (
        <ProfileDialog
            isOpen={isOpen}
            isLoading={!profile}
            onSecondaryButtonClick={onSecondaryButtonClick}
            onSubmit={onSubmit}
            userFullName={profile?.fullName ?? ''}
            userEmailAddress={profile?.email ?? ''}
            additionalDialogContent={
                profile?.organizations && (
                    <Grid
                        data={profile.organizations}
                        sortProperties={[{ id: 'prescriberNpi', desc: false }]}
                        columns={[
                            {
                                accessorKey: 'prescriberNpi',
                                header: 'Prescriber NPI',
                                size: 90,
                            },
                            {
                                accessorKey: 'role',
                                header: 'Role',
                            },
                        ]}
                    />
                )
            }
        />
    );
};

UserProfileDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onSecondaryButtonClick: PropTypes.func.isRequired,
};
